/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Start_Product_Device_HeadingInputs */

const en_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Start using ${i?.displayName} on this device`)
};

const id_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mulai gunakan ${i?.displayName} di perangkat ini`)
};

const ms_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mula gunakan ${i?.displayName} di peranti ini`)
};

const ca_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Començar a utilitzar ${i?.displayName} en aquest dispositiu`)
};

const cs_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Začněte používat ${i?.displayName} na tomto zařízení`)
};

const da_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Begynd at bruge ${i?.displayName} på denne enhed`)
};

const de_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beginne damit, ${i?.displayName} auf diesem Gerät zu verwenden`)
};

const et_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alustage sellel seadmel teenuse ${i?.displayName} kasutamist`)
};

const es_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Empieza a usar ${i?.displayName} en este dispositivo`)
};

const fr_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commencez à utiliser ${i?.displayName} sur cet appareil.`)
};

const hr_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Počnite koristiti ${i?.displayName} na ovom uređaju`)
};

const it_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inizia a usare ${i?.displayName} su questo dispositivo`)
};

const lv_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sākt lietot ${i?.displayName} šajā ierīcē`)
};

const lt_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pradėti naudoti ${i?.displayName} šiame įrenginyje`)
};

const hu_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kezdje el használni a ${i?.displayName} szolgáltatást ezen az eszközön`)
};

const nl_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gebruik ${i?.displayName} op dit apparaat`)
};

const nb_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bruk ${i?.displayName} på denne enheten`)
};

const pl_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zacznij korzystać z ${i?.displayName} na tym urządzeniu`)
};

const pt_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comece a usar o ${i?.displayName} neste dispositivo`)
};

const ro_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Începe să folosești ${i?.displayName} pe acest dispozitiv`)
};

const sk_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Začať používať ${i?.displayName} na tomto zariadení`)
};

const sl_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Začnite uporabljati »${i?.displayName}« v tej napravi`)
};

const fi_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aloita kohteen ${i?.displayName} käyttö tällä laitteella`)
};

const sv_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Börja använda ${i?.displayName} på den här enheten`)
};

const vi_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bắt đầu sử dụng ${i?.displayName} trên thiết bị này`)
};

const tr_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.displayName} hesabını bu cihazda kullanmaya başlayın`)
};

const el_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Αρχίστε να χρησιμοποιείτε το ${i?.displayName} σε αυτή τη συσκευή`)
};

const bg_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Започни да използваш ${i?.displayName} на това устройство`)
};

const ru_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Начните использовать ${i?.displayName} на этом устройстве`)
};

const sr_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Почните да користите функцију ${i?.displayName} на овом уређају`)
};

const uk_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Почніть використовувати ${i?.displayName} на цьому пристрої`)
};

const ka_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`დაიწყეთ ${i?.displayName}-ის გამოყენება ამ მოწყობილობაზე`)
};

const hi_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इस डिवाइस पर ${i?.displayName} इस्तेमाल करना शुरू करें`)
};

const th_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เริ่มใช้ ${i?.displayName} บนอุปกรณ์นี้`)
};

const ko_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`이 기기에서 ${i?.displayName} 사용 시작`)
};

const zh_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`开始在这台设备上使用 ${i?.displayName}`)
};

const zh_tw_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`開始在此裝置上使用 ${i?.displayName}`)
};

const ja_start_product_device_heading = /** @type {(inputs: Start_Product_Device_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`このデバイスで ${i?.displayName} の使用を開始`)
};

/**
* | output |
* | --- |
* | "Start using {displayName} on this device" |
*
* @param {Start_Product_Device_HeadingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const start_product_device_heading = /** @type {((inputs: Start_Product_Device_HeadingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Product_Device_HeadingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_start_product_device_heading(inputs)
	if (locale === "ms") return ms_start_product_device_heading(inputs)
	if (locale === "ca") return ca_start_product_device_heading(inputs)
	if (locale === "cs") return cs_start_product_device_heading(inputs)
	if (locale === "da") return da_start_product_device_heading(inputs)
	if (locale === "de") return de_start_product_device_heading(inputs)
	if (locale === "et") return et_start_product_device_heading(inputs)
	if (locale === "es") return es_start_product_device_heading(inputs)
	if (locale === "fr") return fr_start_product_device_heading(inputs)
	if (locale === "hr") return hr_start_product_device_heading(inputs)
	if (locale === "it") return it_start_product_device_heading(inputs)
	if (locale === "lv") return lv_start_product_device_heading(inputs)
	if (locale === "lt") return lt_start_product_device_heading(inputs)
	if (locale === "hu") return hu_start_product_device_heading(inputs)
	if (locale === "nl") return nl_start_product_device_heading(inputs)
	if (locale === "nb") return nb_start_product_device_heading(inputs)
	if (locale === "pl") return pl_start_product_device_heading(inputs)
	if (locale === "pt") return pt_start_product_device_heading(inputs)
	if (locale === "ro") return ro_start_product_device_heading(inputs)
	if (locale === "sk") return sk_start_product_device_heading(inputs)
	if (locale === "sl") return sl_start_product_device_heading(inputs)
	if (locale === "fi") return fi_start_product_device_heading(inputs)
	if (locale === "sv") return sv_start_product_device_heading(inputs)
	if (locale === "vi") return vi_start_product_device_heading(inputs)
	if (locale === "tr") return tr_start_product_device_heading(inputs)
	if (locale === "el") return el_start_product_device_heading(inputs)
	if (locale === "bg") return bg_start_product_device_heading(inputs)
	if (locale === "ru") return ru_start_product_device_heading(inputs)
	if (locale === "sr") return sr_start_product_device_heading(inputs)
	if (locale === "uk") return uk_start_product_device_heading(inputs)
	if (locale === "ka") return ka_start_product_device_heading(inputs)
	if (locale === "hi") return hi_start_product_device_heading(inputs)
	if (locale === "th") return th_start_product_device_heading(inputs)
	if (locale === "ko") return ko_start_product_device_heading(inputs)
	if (locale === "zh") return zh_start_product_device_heading(inputs)
	if (locale === "zh-tw") return zh_tw_start_product_device_heading(inputs)
	if (locale === "ja") return ja_start_product_device_heading(inputs)
	return en_start_product_device_heading(inputs)
});